module.exports = __webpack_public_path__ + "static/media/down-arrow.92b8bed7.svg";